<template>
<div class="flex item-center justify-center">
    <div class="grid grid-rows-2 gap-2"> <!-- 直2行 -->
        <div class="grid grid-cols-4 gap-2"> <!-- 橫 4 行 -->
            <h1>1</h1>
            <h1>1</h1>
            <h1>1</h1>
            <h1>1</h1>
        </div>

        <div class="grid grid-cols-2 gap-2"> <!-- 橫 2 行 -->
            <h1>1</h1>
            <h1>1</h1>
            <h1>1</h1>
            <h1>1</h1>
        </div>
    </div>
</div>
</template>
<script>
import api from '@/utils/axios';
import { ref } from 'vue';
export default {
    name: 'AppTest',
    data() {
        return {
            sales: ref(),
            }
        },
        method: {
           async getOrderSalesData() {
                const response = await api.get('/report/topcustomerreport');
                console.log('OrderCard: 25');
                this.sales = response.data;
            }
        }
    }
</script>
